<template>
  <b-card class="card-congratulation-medal">
    <h3>Einnahmen</h3>

    <b-card-body>
      <!-- User Stats -->
      <div class="d-flex align-items-center">
        <feather-icon
          icon="DollarSignIcon"
          size="38"
        />
        <div class="d-flex align-items-center mr-4">
          <div class="ml-1">
            <h2 class="mb-0">
              {{ getCustomerRevenue(customerId).toLocaleString('de-DE') }} €
            </h2>
            <small>Einnahmen Gesamt</small>
          </div>
        </div>
        <div class="d-flex align-items-center mr-4">
          <feather-icon
            icon="TrendingUpIcon"
            size="38"
          />
          <div class="ml-1">
            <h2 class="mb-0">
              {{ getCustomerMonthlyRevenue(customerId).toLocaleString('de-DE') }} €
            </h2>
            <small>Monatliche Einnahmen</small>
          </div>
        </div>
        <div class="d-flex align-items-center mr-4">
          <feather-icon
            icon="BoxIcon"
            size="38"
          />
          <div class="ml-1">
            <h2 class="mb-0">
              {{ getCustomerActiveStorageCount(customerId) }}
            </h2>
            <small>Aktive Lager</small>
          </div>
        </div>
        <div class="d-flex align-items-center mr-4">
          <feather-icon
            icon="ShoppingCartIcon"
            size="38"
          />
          <div class="ml-1">
            <h2 class="mb-0">
              {{ getCustomerTotalBookings(customerId) }}
            </h2>
            <small>Buchungen</small>
          </div>
        </div>
      </div>

      <!-- <div>
        <div class="d-flex align-items-center pt-2">
          <feather-icon icon="TrendingUpIcon" size="28" />
          <div class="ml-1">
            <h4 class="mb-0">
              $99.87k
            </h4>
            <small>Einnahmen Gesamt</small>
          </div>
        </div>
      </div> -->
    </b-card-body>
  </b-card>
</template>

<script>
import customerMetrics from '@/helper/customerMetrics'
import {
  BCard,
  BCardHeader,
  BCardBody,
  BBadge,
  BButton,
  BImg,
} from 'bootstrap-vue'

export default {
  setup() {
    const {
      getCustomerRevenue,
      getCustomerMonthlyRevenue,
      getCustomerActiveStorageCount,
      getCustomerTotalBookings
    } = customerMetrics()

    return {
      getCustomerRevenue,
      getCustomerMonthlyRevenue,
      getCustomerActiveStorageCount,
      getCustomerTotalBookings
    }
  },
  directives: {},
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
    BImg,
  },
  props: {
    ordersFromCustomer: {
      type: Array,
      required: true,
    },
    customerId: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style></style>
